import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { IFetchHealthProceduresParams, IHealthProcedures, MedicalViewsType } from '~/interfaces'
import { fetchPatientHealthProcedures, message } from '~/services'

const UNIQUE_KEY = 'healthProcedures'

export const useFetchHealthProcedures = (
  fetchParams: IFetchHealthProceduresParams | null,
  selectedMedicalView: MedicalViewsType | null,
  config?: UseQueryOptions<IHealthProcedures[], Error, IHealthProcedures[]>
): UseQueryResult<IHealthProcedures[], Error> => {
  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')
    if (!selectedMedicalView) throw new Error('selectedMedicalView is required')

    try {
      const response = await fetchPatientHealthProcedures<IHealthProcedures[]>(selectedMedicalView)(fetchParams)
      const isResponseEmpty = response.length === 0

      if (isResponseEmpty) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw message('historic.historicEncounterError')
      }

      return response
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('historic.historicNotFound'))
    }
  }

  return useQuery<IHealthProcedures[], Error>([UNIQUE_KEY, { ...fetchParams, selectedMedicalView }], fetcher, {
    enabled: !!fetchParams && !!selectedMedicalView,
    cacheTime: Infinity,
    staleTime: Infinity,
    ...config
  })
}
